/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { WorkPermitListPageAgent, getAgent } from './agent';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'WorkPermitListPageService';

@injectable()
export class WorkPermitListPageService {
  private static instance: WorkPermitListPageService;
  public agent: WorkPermitListPageAgent;
  static displayName = 'WorkPermitListPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
